// extracted by mini-css-extract-plugin
module.exports = {"ArrowDown":"ArrowDown_ArrowDown__2pTqw","black":"ArrowDown_black__2Vu3Q","lighten":"ArrowDown_lighten__b9KeG","white":"ArrowDown_white__2nSnf","red":"ArrowDown_red__1TcxR"};